import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="password-input"
export default class extends Controller {
  connect() {
  }

  get input(): HTMLInputElement {
    return this.element.querySelector('input');
  }

  get icon(): HTMLElement {
    return this.element.querySelector('i.show-icon');
  }

  toggleShow = e => {
    const newType = this.input.type === 'password' ? 'text' : 'password';
    this.input.type = newType;
    if (newType === 'password') {
      this.icon.classList.remove('fa-eye-slash');
      this.icon.classList.add('fa-eye');
    }
    else {
      this.icon.classList.add('fa-eye-slash');
      this.icon.classList.remove('fa-eye');
    }
  }
}
